import React from "react";
import {
  FaSearchLocation,
  FaWhatsapp,
  FaTelegram,
  FaYoutube,
} from "react-icons/fa";
import { BsTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#fffbf4] text-stone-700 relative overflow-hidden border-t border-amber-200">
      {/* Subtle radial glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(251,191,36,0.03),transparent_70%)] pointer-events-none"></div>

      {/* Top Section */}
      <div className="relative z-10 px-6 lg:px-16 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 max-w-7xl mx-auto">
        {/* ABOUT */}
        <div className="flex flex-col items-center lg:items-start text-center lg:text-left">
          <h3 className="text-amber-950 font-serif text-xl font-bold mb-5 tracking-wide">
            Radha Krishna Gram Vikas Kendra
          </h3>
          <p className="text-stone-600 leading-relaxed text-sm md:text-base font-light">
            Radha Krishna Gram Vikas Kendra is a dedicated society working for rural
            education, cultural propagation, and the teachings of Srimad Bhagavad Gita
            under the guidance of Bramha-Madhva-Gaudiya Sampradaya (ISKCON).
          </p>
        </div>

        {/* SOCIAL LINKS */}
        <div className="flex flex-col items-center text-center">
          <h3 className="text-amber-950 font-serif text-xl font-bold mb-5 tracking-wide">
            Connect With Us
          </h3>
          <div className="flex gap-6 mt-2">
            <Link
              to="https://chat.whatsapp.com/EAob3SvLrMRB9VYm48iPtf"
              target="_blank"
              className="hover:scale-110 hover:-translate-y-1 transition-all duration-300 bg-white p-3 rounded-full border border-stone-200 hover:border-emerald-500 hover:bg-emerald-50/20 group"
            >
              <FaWhatsapp className="text-2xl text-stone-500 group-hover:text-emerald-600 transition-colors" />
            </Link>
            <Link
              to="https://t.me/+iaFiUK6gqso1YzU1"
              target="_blank"
              className="hover:scale-110 hover:-translate-y-1 transition-all duration-300 bg-white p-3 rounded-full border border-stone-200 hover:border-sky-500 hover:bg-sky-50/20 group"
            >
              <FaTelegram className="text-2xl text-stone-500 group-hover:text-sky-600 transition-colors" />
            </Link>
            <Link
              to="https://www.youtube.com/@ssgdnhk"
              target="_blank"
              className="hover:scale-110 hover:-translate-y-1 transition-all duration-300 bg-white p-3 rounded-full border border-stone-200 hover:border-red-500 hover:bg-red-50/20 group"
            >
              <FaYoutube className="text-2xl text-stone-500 group-hover:text-red-600 transition-colors" />
            </Link>
          </div>
          <p className="mt-6 text-stone-500 font-medium italic text-sm">
            “Stay connected, stay blessed.”
          </p>
        </div>

        {/* CONTACT INFO */}
        <div className="flex flex-col items-center lg:items-start text-center lg:text-left">
          <h3 className="text-amber-950 font-serif text-xl font-bold mb-5 tracking-wide">Contact Us</h3>
          <div className="flex flex-col gap-4 text-left text-sm md:text-base font-light text-stone-600">
            <div className="flex gap-3 items-start">
              <FaSearchLocation className="text-lg text-amber-700 mt-1 shrink-0" />
              <p className="leading-relaxed">
                Jaipalpur (Chaka), Mungra Badshahpur, <br />
                Jaunpur, U.P — 222202
              </p>
            </div>
            <div className="flex gap-3 items-center">
              <BsTelephoneFill className="text-base text-amber-700 shrink-0" />
              <p>+91-7042109297, +91-7525858518</p>
            </div>
            <div className="flex gap-3 items-center">
              <MdEmail className="text-base text-amber-700 shrink-0" />
              <Link
                to="mailto:radhakrishnagramvikaskendra@gmail.com"
                className="hover:text-amber-700 transition-colors break-all font-medium"
              >
                radhakrishnagramvikaskendra@gmail.com
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Divider Line */}
      <div className="border-t border-amber-200/50 max-w-7xl mx-auto"></div>

      {/* Bottom Section */}
      <div className="relative z-10 py-6 bg-amber-50 text-center border-t border-amber-100">
        <p className="text-stone-500 text-xs md:text-sm">
          © {new Date().getFullYear()}{" "}
          <span className="font-semibold text-stone-700">Radha Krishna Gram Vikas Kendra</span>{" "}
          — All Rights Reserved.
        </p>
        <p className="text-amber-800/80 text-xs mt-2 italic tracking-widest uppercase font-semibold">
          जय श्री कृष्णा 🙏 | Hare Krishna 🌸
        </p>
      </div>
    </footer>
  );
};

export default Footer;
